import { render } from "./design-multiselect.vue?vue&type=template&id=4e939655&scoped=true&ts=true"
import script from "./design-multiselect.vue?vue&type=script&lang=ts"
export * from "./design-multiselect.vue?vue&type=script&lang=ts"

import "./design-multiselect.vue?vue&type=style&index=0&id=4e939655&scoped=true&lang=css"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e939655"]])

export default __exports__